import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import _get from 'lodash/get';
import { emitter } from '@marvelapp/react-ab-test';
import {
  PRACTICES_NAV_TEST_NAME,
  VARIANT_LEARNING_LAB_LINK,
  VARIANT_DIRECT_PRACTICES_LINK,
} from 'utils/abTestsUtils';
import { hasLearningLabResources } from 'containers/Main/selectors';
import { isClientFeatureAllowed } from 'containers/Main/utils';
import useClientExcludedResourceType from 'components/Hooks/useClientExcludedResourceType';
import useSiteConfigSelector from 'components/useSiteConfigSelector';

function getActiveVariant() {
  try {
    return (
      emitter.getActiveVariant(PRACTICES_NAV_TEST_NAME) ||
      VARIANT_LEARNING_LAB_LINK
    );
  } catch (error) {
    return VARIANT_LEARNING_LAB_LINK;
  }
}

function isPracticesNavAbTestAllowedByConfig(featuresConfig, clientDetails) {
  const abTestConfig = _get(featuresConfig, 'config.practicesNavAbTest');
  if (!abTestConfig) return true;
  return isClientFeatureAllowed(abTestConfig, clientDetails);
}

export default function usePracticesNavAbTest() {
  const isLearningLabEnabled = useSelector(hasLearningLabResources);
  const { isResourceTypeExcluded } = useClientExcludedResourceType();
  const [featuresConfig] = useSiteConfigSelector(['Features']);
  const clientDetails = useSelector(state => state.main.clientDetails);

  const isTestEnabled = useMemo(() => {
    const practicesExcluded = isResourceTypeExcluded('practice');
    const allowedByConfig = isPracticesNavAbTestAllowedByConfig(
      featuresConfig,
      clientDetails,
    );
    return isLearningLabEnabled && !practicesExcluded && allowedByConfig;
  }, [
    isLearningLabEnabled,
    isResourceTypeExcluded,
    featuresConfig,
    clientDetails,
  ]);

  const menuVariant = isTestEnabled
    ? getActiveVariant()
    : VARIANT_LEARNING_LAB_LINK;

  return {
    isTestEnabled,
    menuVariant,
  };
}

export { VARIANT_LEARNING_LAB_LINK, VARIANT_DIRECT_PRACTICES_LINK };
